import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const CATEGORY_LABELS = {
  preventivi: "Preventivi",
  reclami: "Reclami",
  fatture: "Fatture",
  ordini: "Ordini",
  assistenza: "Assistenza",
  contratti: "Contratti",
  guasto: "Guasto",
  morosita: "Morosità",
  assemblea: "Assemblea",
  comunicazione_legale: "Legale/PEC",
  da_analizzare: "Da analizzare",
  altro: "Altro",
};

export const CATEGORY_STYLES = {
  preventivi: "bg-blue-100 text-blue-800 border-blue-200",
  reclami: "bg-red-100 text-red-800 border-red-200",
  fatture: "bg-emerald-100 text-emerald-800 border-emerald-200",
  ordini: "bg-purple-100 text-purple-800 border-purple-200",
  assistenza: "bg-amber-100 text-amber-800 border-amber-200",
  contratti: "bg-slate-100 text-slate-800 border-slate-200",
  guasto: "bg-orange-100 text-orange-800 border-orange-200",
  morosita: "bg-rose-100 text-rose-800 border-rose-200",
  assemblea: "bg-indigo-100 text-indigo-800 border-indigo-200",
  comunicazione_legale: "bg-cyan-100 text-cyan-800 border-cyan-200",
  da_analizzare: "bg-slate-100 text-slate-500 border-slate-200",
  altro: "bg-gray-100 text-gray-700 border-gray-200",
};

export const COLOR_STYLES = {
  blue: "bg-blue-100 text-blue-800 border-blue-200",
  red: "bg-red-100 text-red-800 border-red-200",
  emerald: "bg-emerald-100 text-emerald-800 border-emerald-200",
  purple: "bg-purple-100 text-purple-800 border-purple-200",
  amber: "bg-amber-100 text-amber-800 border-amber-200",
  slate: "bg-slate-100 text-slate-800 border-slate-200",
  orange: "bg-orange-100 text-orange-800 border-orange-200",
  rose: "bg-rose-100 text-rose-800 border-rose-200",
  indigo: "bg-indigo-100 text-indigo-800 border-indigo-200",
  cyan: "bg-cyan-100 text-cyan-800 border-cyan-200",
  gray: "bg-gray-100 text-gray-700 border-gray-200",
  teal: "bg-teal-100 text-teal-800 border-teal-200",
  pink: "bg-pink-100 text-pink-800 border-pink-200",
  violet: "bg-violet-100 text-violet-800 border-violet-200",
  sky: "bg-sky-100 text-sky-800 border-sky-200",
  lime: "bg-lime-100 text-lime-800 border-lime-200",
  fuchsia: "bg-fuchsia-100 text-fuchsia-800 border-fuchsia-200",
};

export const PRIORITY_STYLES = {
  alta: "bg-red-500 text-white",
  media: "bg-amber-400 text-black",
  bassa: "bg-slate-300 text-slate-800",
};

export const EXTRACT_LABELS = {
  nomi: "Nomi",
  importi: "Importi",
  scadenze: "Scadenze",
  codici_fiscali: "Codici Fiscali",
  numeri_pratica: "N. Pratica",
  indirizzi: "Indirizzi",
  partite_iva: "Partite IVA",
  iban: "IBAN",
  stabile: "Stabile",
  millesimi: "Millesimi",
  importo_rata: "Importo Rata",
  fornitore: "Fornitore",
};
